export default "__VITE_ASSET__B6nfJL9$__"